'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var addTeacher = function addTeacher() {
  return import('@/page/user-center/teacher-groom/add-teacher.vue');
};
var addSuccess = function addSuccess() {
  return import('@/page/user-center/teacher-groom/add-success.vue');
};
var lookTeacher = function lookTeacher() {
  return import('@/page/user-center/teacher-groom/look-teacher.vue');
};

exports.default = [{
  path: '/addTeacher',
  name: 'addTeacher',
  component: addTeacher
}, {
  path: '/addSuccess',
  name: 'addSuccess',
  component: addSuccess
}, {
  path: '/lookTeacher',
  name: 'lookTeacher',
  component: lookTeacher
}];